import React from "react";
import { MonitorIcon, SmartphoneIcon, GlobeSmallIcon } from "./AnalyticsIcons";
import ReusableTable from "../shared/ReusableTable";

const LOGIN_DATA = [
  { date: "2024-01-15", time: "09:30 AM", ip: "192.168.1.1", device: "Chrome / Windows", type: "desktop", location: "Mumbai, India" },
  { date: "2024-01-14", time: "10:15 AM", ip: "192.168.1.1", device: "Safari / macOS", type: "desktop", location: "Mumbai, India" },
  { date: "2024-01-13", time: "08:45 AM", ip: "192.168.1.2", device: "Chrome / Android", type: "mobile", location: "Pune, India" },
  { date: "2024-01-12", time: "11:00 AM", ip: "192.168.1.1", device: "Firefox / Windows", type: "desktop", location: "Mumbai, India" },
  { date: "2024-01-11", time: "09:00 AM", ip: "192.168.1.3", device: "Safari / iOS", type: "mobile", location: "Delhi, India" },
];

const LOGIN_COLUMNS = [
  { key: "date", label: "Date" },
  { key: "time", label: "Time" },
  {
    key: "ip",
    label: "IP Address",
    render: (val) => <code className="v2-shared-tbl__ip">{val}</code>,
  },
  {
    key: "device",
    label: "Device",
    render: (val, row) => (
      <span className="v2-shared-tbl__icon-text">
        {row.type === "mobile" ? (
          <SmartphoneIcon size={16} color="#9ca3af" />
        ) : (
          <MonitorIcon size={16} color="#9ca3af" />
        )}
        {val}
      </span>
    ),
  },
  {
    key: "location",
    label: "Location",
    render: (val) => (
      <span className="v2-shared-tbl__icon-text">
        <GlobeSmallIcon size={15} color="#9ca3af" />
        {val}
      </span>
    ),
  },
];

const AnalyticsLoginHistory = () => {
  return (
    <div className="v2-analytics-pg-history">
      <div className="v2-analytics-pg-history__header">
        <h3 className="v2-analytics-pg-history__title">Login History</h3>
        <p className="v2-analytics-pg-history__subtitle">
          Recent sign-in activity on your account
        </p>
      </div>
      <ReusableTable columns={LOGIN_COLUMNS} data={LOGIN_DATA} />
    </div>
  );
};

export default AnalyticsLoginHistory;
